module.exports = __webpack_public_path__ + "files/a2916cfab49e74d31f487f7ead421c51.png";